export var EncTotals;
(function (EncTotals) {
    function make() {
        return {
            grand: {
                column: false,
                row: false,
            },
            subtotal: {
                column: false,
                row: false,
            },
        };
    }
    EncTotals.make = make;
    let Direction;
    (function (Direction) {
        Direction["Column"] = "column";
        Direction["Row"] = "row";
    })(Direction = EncTotals.Direction || (EncTotals.Direction = {}));
})(EncTotals || (EncTotals = {}));
